'use strict';
var AV = require('leancloud-storage');
AV.initialize(window.CONFIG.leancloud.appID, window.CONFIG.leancloud.appKey);
function showTime(Counter) {
    var query = new AV.Query(Counter);
    var entries = [];
    var $visitors = $('.leancloud_visitors');
    $visitors.each(function () {
        entries.push($(this).attr('id').trim());
    });
    query.containedIn('url', entries);
    query.find().then(function (results) {
        var COUNT_CONTAINER_REF = '.leancloud-visitors-count';
        if (results.length === 0) {
            $visitors.find(COUNT_CONTAINER_REF).text(0);
            return;
        }
        for (var i = 0; i < results.length; i++) {
            var item = results[i];
            var url = item.get('url');
            var time = item.get('time');
            var element = document.getElementById(url);
            $(element).find(COUNT_CONTAINER_REF).text(time);
        }
        for (var i = 0; i < entries.length; i++) {
            var url = entries[i];
            var element = document.getElementById(url);
            var countSpan = $(element).find(COUNT_CONTAINER_REF);
            if (countSpan.text() == '') {
                countSpan.text(0);
            }
        }
    }).then(function (object, error) {
        console.log('Error: ' + error.code + ' ' + error.message);
    });
}
function addCount(Counter) {
    var $visitors = $('.leancloud_visitors');
    var url = $visitors.attr('id').trim();
    var title = $visitors.attr('data-flag-title').trim();
    var query = new AV.Query(Counter);
    query.equalTo('url', url);
    query.find().then(function (results) {
        if (results.length > 0) {
            var counter = results[0];
            counter.fetchWhenSave(true);
            counter.increment('time');
            counter.save().then(function (counter) {
                var $element = $(document.getElementById(url));
                $element.find('.leancloud-visitors-count').text(counter.get('time'));
            }).then(function (counter, error) {
                console.log('Failed to save Visitor num, with error message: ' + error.message);
            });
        } else {
            var newcounter = new Counter();
            var acl = new AV.ACL();
            acl.setPublicReadAccess(true);
            acl.setPublicWriteAccess(true);
            newcounter.setACL(acl);
            newcounter.set('title', title);
            newcounter.set('url', url);
            newcounter.set('time', 1);
            newcounter.save().then(function (newcounter) {
                var $element = $(document.getElementById(url));
                $element.find('.leancloud-visitors-count').text(newcounter.get('time'));
            }).then(function (newcounter, error) {
                console.log('Failed to create');
            });
        }
    }).then(function (error) {
        console.log('Error:' + error.code + ' ' + error.message);
    });
}
$(function () {
    var Counter = AV.Object.extend('Counter');
    if ($('.leancloud_visitors').length == 1) {
        addCount(Counter);
    } else if ($('.post-title-link').length > 1) {
        showTime(Counter);
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/leancloud.js
// module id = 17
// module chunks = 0